import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { ActivePointDetailDTO } from "../../models/dtos/management/ActivePointDetailDTO";
import { ActivePointsDTO } from "../../models/dtos/management/ActivePointsDTO";
import { PointCountDTO } from "../../models/dtos/management/PointCountDTO";
import { PointsRowDTO } from "../../models/dtos/management/PointsRowDTO";
import { PointsUserDTO } from "../../models/dtos/management/PointsUserDTO";
import { TopStudentsPointDTO } from "../../models/dtos/management/TopStudentsPointDTO";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import { PointsQueryString } from "../../models/query-strings/profile/PointsQueryString";
import BaseService from "../base/BaseService";

export default class PointsService extends BaseService {
    getPoints(): Promise<PointsUserDTO[]> {
        return axios.get(`/Points/GetPage`)
            .then(function (response: AxiosResponse<PointsUserDTO[], any>) {
                return response.data;
            });
    }

    getPointsCount(): Promise<PointCountDTO> {
        return axios.get(`/Points/GetCount`)
            .then(function (response: AxiosResponse<PointCountDTO, any>) {
                return response.data;
            });
    }

    getDetailPoints(query: PointsQueryString): Promise<PointsRowDTO> {
        return axios.get(`/Points/Details`, { params: query })
            .then(function (response: AxiosResponse<PointsRowDTO, any>) {
                return response.data;
            });
    }

    getActivePoints(query: QueryPagesDTO): Promise<TableData<ActivePointsDTO>> {
        return axios.get(`/Points/GetActivePoints`, { params: query })
            .then(function (response: AxiosResponse<TableData<ActivePointsDTO>, any>) {
                return response.data;
            });
    }

    getPointDetail(id: number): Promise<ActivePointDetailDTO> {
        return axios.get(`/Points/PointDetail/${id}`)
            .then(function (response: AxiosResponse<ActivePointDetailDTO, any>) {
                return response.data;
            });
    }

    getReceivedPointList(userId: string): Promise<PointsUserDTO[]> {
        return axios.get(`/Points/User/${userId}`)
            .then(function (response: AxiosResponse<PointsUserDTO[], any>) {
                return response.data;
            });
    }

    topStudents(): Promise<TopStudentsPointDTO> {
        return axios.get(`/Points/TopUsers`)
            .then(function (response: AxiosResponse<TopStudentsPointDTO, any>) {
                return response.data;
            });
    }
}